import { Box, CircularProgress, CircularProgressProps } from "@mui/material";
import * as S from "./styles";

interface FutCircularProps extends CircularProgressProps {}

export default function FutCircularProgress({
  className,
  ...props
}: FutCircularProps) {
  const { value, ...propsNoValue } = props;

  return (
    <>
      <div
        style={{
          position: "absolute",
          inset: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        className={className}
      >
        <S.CircularBackground
          variant="determinate"
          value={100}
          {...propsNoValue}
        />
        <S.StyledCircularProgress variant="determinate" {...props} />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <p>{`${value}%`}</p>
        </Box>
      </div>
    </>
  );
}
